/**
 * Builds a Set<string> of composite keys ("codeType:code") from resolverIdealCodes,
 * used for O(1) per-chip lookup in MedicalCodesManager.
 *
 * Key format examples: "procedure:99213", "diagnosis:Z87.01", "modifier:59"
 * Returns null when no resolver result is available (no decorations should render).
 */
export const selectIdealCodeKeys = (
  state: CMx.ApplicationState
): Set<string> | null => {
  const codes = state.gradeBenchPanel?.resolverIdealCodes;
  if (!codes) return null;
  return new Set(
    codes.map(c => `${c.codeType.toLowerCase()}:${String(c.code)}`)
  );
};

export const selectIdealCodeIds = (
  state: CMx.ApplicationState
): Set<number> | null => {
  const codes = state.gradeBenchPanel?.resolverIdealCodes;
  if (!codes) return null;
  return new Set(codes.map(c => c.id));
};
